<template>
    <v-card id="addtagcard" :color="alertlevel" class="drag_overlay borderless d-flex flex-column" fluid flat style="height:100%; width: 100%">

        <v-toolbar style="overflow:hidden" :color="alertlevel" flat dense class="pb-0">
            <v-toolbar-items>
                <div class="pa-1 mx-5 black--text menuhead" text tile>Choose alert</div>
                <v-spacer></v-spacer>
                <v-btn icon text v-if="alerttab" @click="rateImportance"><img src="assets/traffic-light.png" height="20" width="20"></v-btn>
                <v-btn icon text @click="confirmAddTag" :disabled="!tagselected"><v-icon>add_circle</v-icon></v-btn>
                <v-btn icon text @click="cancelAddTag"><img src="assets/close.png" height="20" width="20"></v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-toolbar style="overflow:hidden" v-if="setalert" :color="alertlevel" flat dense class="pb-0">
            <v-toolbar-items>
                <div class="pa-1 mx-5 black--text menuhead" text tile>Set alert level</div>
                <v-spacer></v-spacer>
                <v-btn icon text @click="setAlertLevel(1)"><img src="assets/green-alert.png" height="20" width="20"></v-btn>
                <v-btn icon text @click="setAlertLevel(2)"><img src="assets/amber-alert.png" height="20" width="20"></v-btn>
                <v-btn icon text @click="setAlertLevel(3)"><img src="assets/red-alert.png" height="20" width="20"></v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card :color="alertlevel" flat>
            <v-tabs :background-color="alertlevel" center-active @change="tabChanged">
                <v-tab>Mark-Up</v-tab>
                <v-tab>Rate</v-tab>
                <v-tab>HSE</v-tab>
                <v-tab>Lean</v-tab>
            </v-tabs>
            <v-card :color="alertlevel" v-if="chosentab == 0">
            </v-card>
            <v-card :color="alertlevel" v-if="chosentab == 1">
                <v-btn id="tick-in-circle" class="ma-1" icon @click="clickIcon('tick-in-circle')"><img src="assets/tick-in-circle.png"></v-btn>
                <v-btn id="cross-in-circle" class="ma-1" icon @click="clickIcon('cross-in-circle')"><img src="assets/cross-in-circle.png"></v-btn>
                <v-btn id="thumb-up" class="ma-1" icon @click="clickIcon('thumb-up')"><img src="assets/thumb-up.png"></v-btn>
                <v-btn id="thumb-down" class="ma-1" icon @click="clickIcon('thumb-down')"><img src="assets/thumb-down.png"></v-btn>
            </v-card>
            <v-card :color="alertlevel" v-if="chosentab == 2">
                <v-btn id="hse_first_aid" class="ma-1" icon @click="clickIcon('hse_first_aid')"><img src="assets/hse_first_aid.png"></v-btn>
                <v-btn id="hse_first_aid_exit" class="ma-1" icon @click="clickIcon('hse_first_aid_exit')"><img src="assets/hse_first_aid_exit.png"></v-btn>
                <v-btn id="hse_first_aid_eyewash" class="ma-1" icon @click="clickIcon('hse_first_aid_eyewash')"><img src="assets/hse_first_aid_eyewash.png"></v-btn>
                <v-btn id="hse_first_aid_poster" class="ma-1" icon @click="clickIcon('hse_first_aid_poster')"><img src="assets/hse_first_aid_poster.png"></v-btn>
                <v-btn id="hse_first_aid_shower" class="ma-1" icon @click="clickIcon('hse_first_aid_shower')"><img src="assets/hse_first_aid_shower.png"></v-btn>
                <v-btn id="hse_first_aid_stretcher" class="ma-1" icon @click="clickIcon('hse_first_aid_stretcher')"><img src="assets/hse_first_aid_stretcher.png"></v-btn>
                <v-btn id="hse_first_aid_telephone" class="ma-1" icon @click="clickIcon('hse_first_aid_telephone')"><img src="assets/hse_first_aid_telephone.png"></v-btn>
                <v-btn id="hse_mandatory_boots" class="ma-1" icon @click="clickIcon('hse_mandatory_boots')"><img src="assets/hse_mandatory_boots.png"></v-btn>
                <v-btn id="hse_mandatory_ears" class="ma-1" icon @click="clickIcon('hse_mandatory_ears')"><img src="assets/hse_mandatory_ears.png"></v-btn>
                <v-btn id="hse_mandatory_face" class="ma-1" icon @click="clickIcon('hse_mandatory_face')"><img src="assets/hse_mandatory_face.png"></v-btn>
                <v-btn id="hse_mandatory_glasses" class="ma-1" icon @click="clickIcon('hse_mandatory_glasses')"><img src="assets/hse_mandatory_glasses.png"></v-btn>
                <v-btn id="hse_mandatory_gloves" class="ma-1" icon @click="clickIcon('hse_mandatory_gloves')"><img src="assets/hse_mandatory_gloves.png"></v-btn>
                <v-btn id="hse_mandatory_helmet" class="ma-1" icon @click="clickIcon('hse_mandatory_helmet')"><img src="assets/hse_mandatory_helmet.png"></v-btn>
                <v-btn id="hse_mandatory_overall" class="ma-1" icon @click="clickIcon('hse_mandatory_overall')"><img src="assets/hse_mandatory_overall.png"></v-btn>
                <v-btn id="hse_mandatory_pedestrian" class="ma-1" icon @click="clickIcon('hse_mandatory_pedestrian')"><img src="assets/hse_mandatory_pedestrian.png"></v-btn>
                <v-btn id="hse_prohibited_pedestrians" class="ma-1" icon @click="clickIcon('hse_prohibited_pedestrians')"><img src="assets/hse_prohibited_pedestrians.png"></v-btn>
                <v-btn id="hse_prohibited_smoking" class="ma-1" icon @click="clickIcon('hse_prohibited_smoking')"><img src="assets/hse_prohibited_smoking.png"></v-btn>
                <v-btn id="hse_prohibited_touch" class="ma-1" icon @click="clickIcon('hse_prohibited_touch')"><img src="assets/hse_prohibited_touch.png"></v-btn>
                <v-btn id="hse_prohibited_vehicles" class="ma-1" icon @click="clickIcon('hse_prohibited_vehicles')"><img src="assets/hse_prohibited_vehicles.png"></v-btn>
                <v-btn id="hse_warning_bio" class="ma-1" icon @click="clickIcon('hse_warning_bio')"><img src="assets/hse_warning_bio.png"></v-btn>
                <v-btn id="hse_warning_electrical" class="ma-1" icon @click="clickIcon('hse_warning_electrical')"><img src="assets/hse_warning_electrical.png"></v-btn>
                <v-btn id="hse_warning_explosives" class="ma-1" icon @click="clickIcon('hse_warning_explosives')"><img src="assets/hse_warning_explosives.png"></v-btn>
                <v-btn id="hse_warning_flammable" class="ma-1" icon @click="clickIcon('hse_warning_flammable')"><img src="assets/hse_warning_flammable.png"></v-btn>
                <v-btn id="hse_warning_general" class="ma-1" icon @click="clickIcon('hse_warning_general')"><img src="assets/hse_warning_general.png"></v-btn>
                <v-btn id="hse_warning_radioactive" class="ma-1" icon @click="clickIcon('hse_warning_radioactive')"><img src="assets/hse_warning_radioactive.png"></v-btn>
                <v-btn id="hse_warning_toxic" class="ma-1" icon @click="clickIcon('hse_warning_toxic')"><img src="assets/hse_warning_toxic.png"></v-btn>
                <v-btn id="hse_warning_trip" class="ma-1" icon @click="clickIcon('hse_warning_trip')"><img src="assets/hse_warning_trip.png"></v-btn>
                <v-btn id="hse_warning_vehicles" class="ma-1" icon @click="clickIcon('hse_warning_vehicles')"><img src="assets/hse_warning_vehicles.png"></v-btn>
            </v-card>
            <v-btn id="highlighter" v-if="tagselected" class="ma-0" :style=hstyle icon @click="clickIcon('highlighter')"><img src="assets/highlighter.png"></v-btn>
            <v-card id="textbox" :height="100" color="#FFFFFF">
                <v-textarea class="mt-6 text-wrap" name="note" label=" Note (optional)" v-model="note" :rules="noteRules"></v-textarea>
            </v-card>
        </v-card>
    </v-card>
</template>

<script>

    import { dateticks, firebaseid, updatetag } from '@/functions.js';

    export default {
        name: "AddTag",
        mounted: function () {
            this.loadgoodbadtags();
        },
        data() {
            return {
                rating: "grey",
                alerttab:false,
                alertlevel: "#999999",
                setalert: false,
                hstyle: "position: absolute; left:20px; top: 20px",
                selectedtag: "",
                note:"",
                tagselected: false,
                chosentab: 0,
                noteRules: [             
                ],
                goodbadtags: {}
            };
        },
        methods: {
            loadgoodbadtags() {
                this.goodbadtags["tick-in-circle"] = { rating: "green#" };
                this.goodbadtags["cross-in-circle"] = { rating: "red#" };
                this.goodbadtags["thumb-up"] = { rating: "green#" };
                this.goodbadtags["thumb-down"] = { rating: "red#" };
            },
            tabChanged(event) {
                this.chosentab = event;
                if (this.chosentab == 0) {
                    this.alerttab = false;
                    this.alertlevel = "#999999";
                    this.rating = "grey";
                    this.$store.state.navdrawerheight = 275;
                }
                if (this.chosentab == 1) {
                    this.alerttab = false;
                    this.alertlevel = "#999999";
                    this.rating = "grey";
                    this.$store.state.navdrawerheight = 275;
                }
                if (this.chosentab == 2) {
                    this.alerttab = true;
                    this.alertlevel = "#FFA500";
                    this.rating = "amber";
                    this.$store.state.navdrawerheight = 400;
                }
                if (this.chosentab == 3) {
                    this.alerttab = false;
                    this.alertlevel = "#999999";
                    this.rating = "grey";
                    this.$store.state.navdrawerheight = 275;
                }
                this.tagselected = false;
            },
            clickIcon(icn) {
                if (icn === "highlighter")
                    this.tagselected = false;
                else {
                    this.tagselected = true;
                    this.selectedtag = icn;
                    var left = document.getElementById(icn).getBoundingClientRect().left;
                    var top = document.getElementById(icn).getBoundingClientRect().top - 48;
                    this.hstyle = "position: absolute; left:" + left + "px; top: " + top + "px";
                }
            },
            filterText() {
                var txt = escape(this.note);
                return txt;
            },
            rateImportance() {
                this.setalert = true;
            },
            setAlertLevel(lev) {
                if (lev == 0) {
                    this.alertlevel = "#999999";
                    this.rating = "grey";
                }
                if (lev == 1) {
                    this.alertlevel = "#00FF00";
                    this.rating = "green";
                }
                if (lev == 2) {
                    this.alertlevel = "#FFA500";
                    this.rating = "amber";
                }
                if (lev == 3) {
                    this.alertlevel = "#FF0000";
                    this.rating = "red";
                }
                this.$store.state.alertlevel = this.alertlevel;
                this.setalert = false;
            },
            addNote(tag) {
                if (tag.Notes == null) {
                    tag.Notes = new Object();
                };
                var newnote = {};
                newnote.CreatorID = this.$store.state.currentuser.ID;
                newnote.CreatorTag = this.$store.state.currentuser.Tag;
                newnote.Time = tag.Time;
                var noteid = "" + tag.Time;
                newnote.Text = this.filterText();
                tag.Notes[noteid] = newnote;
            },
            confirmAddTag() {
                this.$store.state.clickmode = "normal";
                this.$store.state.addtagvisible = false;
                this.$store.state.tagconfirmed = true;
                var tag = {};
                tag.Alert = false;
                tag.IsMediaTag = true;
                tag.CreatorID = this.$store.state.currentuser.ID;
                tag.CreatorTag = this.$store.state.currentuser.Tag;
                tag.MediaID = this.$store.state.mediaID;
                tag.Pitch = this.$store.state.pitch;
                tag.Total = 1;  
                if (this.rating === "grey") {
                    this.rating = this.goodbadtags[this.selectedtag].rating;
                }
                tag.Rating = this.rating;
                tag.Time = dateticks();
                if (this.note.length > 0)
                    this.addNote(tag);
                tag.Type = this.selectedtag;
                tag.Yaw = this.$store.state.yaw;
                var tagid = firebaseid(tag.Time);
                updatetag(tag,tagid,true);
                this.tagselected = false;
                this.note = "";
                //this.rating = "grey";
            },
            cancelAddTag() {
                this.$store.state.clickmode = "addtag";
                this.$store.state.addtagvisible = false;
                this.tagselected = false;
                this.note = "";
            }
        },
        computed: {
        }
    };
</script>